import { faCircleExclamation, faCircleQuestion, faInfoCircle, faWarning } from "@fortawesome/pro-regular-svg-icons";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useMount } from "react-use";
import { registerErrorMsgHandler2 } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import Button from "../button/Button";
import "./ErrorOverlay.scss";
import { useTranslation } from "react-i18next";
import { UIReply } from "userful-chronos-app-common-js/dist/models/common";
import i18next from "i18next";
import StandaloneFeatureNotAvailable from "../Widgets/StandaloneFeatureNotAvailable";
import { getGlobalStates, isStandalone } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import SCHAE5 from "./specialErrors/SCHAE5";
import UCSTO1 from "./specialErrors/UCSTO1";
import UCSTO2 from "./specialErrors/UCSTO2";
import UserfulConfirmationDialog from "../ConfirmationDialog/UserfulConfirmationDialog";
import { t } from "i18next";

const HDMI_DEVICE_ERROR = "Decklinkvideosrc failed to acquire input";

const IGNORED_ERRORS: string[] = [
    "UCNLB-1",
    "UCNOP-1",
    "UCNOP-2",
    "UCNOP-3",
    "UCNOP-4",
    "UCNOP-5",
    "UCNOP-6",
    "UCNOP-7",
    "UCNOP-8",
    "UCNOP-9",
    "UCNOP-10",
];

const isErrorIgnored = (error: UIReply<any>): boolean =>
    error && IGNORED_ERRORS.includes(`${error.moduleID}-${error.errorCode}`);

interface IProps {
    disabled?: boolean;
}

export default function ({ disabled }: IProps) {
    const { t } = useTranslation();

    const [error, setError] = useState<UIReply<any>>(null);

    useMount(() => {
        if (!disabled) {
            registerErrorMsgHandler2((data) => {
                if (getGlobalStates().eventBus && !getGlobalStates()?.eventBus?.rebooting) {
                    setError(data);
                } else if (!getGlobalStates().eventBus) {
                    setError(data);
                }
            });
        }
    });

    const handleClose = () => setError(null);
    if (disabled || !error) {
        return null;
    }

    const getTranslatedErrorMsg = (error: UIReply<any>) => {
        if (!error) {
            return "";
        }
        if (error.msg?.includes(HDMI_DEVICE_ERROR)) {
            return t(`Error.error.HDMI_DEVICE_ERROR`);
        }
        const errorParamsObj = {};
        for (const param of error.params) {
            errorParamsObj[param.name] = param.value;
        }
        if (i18next.exists(`Error.error.${error.moduleID}-${error.errorCode}`)) {
            return t(`Error.error.${error.moduleID}-${error.errorCode}`, errorParamsObj);
        }
        console.debug(`Error msg translation does not exist for ${error.moduleID}-${error.errorCode}`);
        return error.msg;
    };

    if (error && error.moduleID === "SCHAE" && error.errorCode === 5) {
        return <SCHAE5 error={error} handleClose={handleClose} />;
    }
    if (error && error.moduleID === "UCSTO" && error.errorCode === 1) {
        return <UCSTO1 error={error} handleClose={handleClose} />;
    }
    if (error && error.moduleID === "UCSTO" && error.errorCode === 2) {
        return <UCSTO2 error={error} handleClose={handleClose} />;
    }

    let icon: {
        icon: any;
        color?: string;
    } = { icon: faCircleQuestion, color: "#91A7EE" };
    let variant = "primary";
    let title = "Shared.unknown";

    if (error) {
        if (error.severity === "INFO") {
            icon = { icon: faInfoCircle, color: "#1F2747" };
            title = "Shared.information";
        } else if (error.severity === "WARN") {
            icon = { icon: faWarning, color: "#FFA200" };
            variant = "warning";
            title = "Shared.warning";
        } else if (error.severity === "FATAL") {
            icon = { icon: faCircleExclamation, color: "#D13E2C" };
            variant = "danger";
            title = "Shared.error";
        }
    }

    return (
        <>
            <UserfulConfirmationDialog
                show={!!error && !isErrorIgnored(error)}
                onCancel={handleClose}
                title={title}
                icon={icon}
                gap={4}
                replaceBody={
                    <StandaloneFeatureNotAvailable>
                        {t("Error.errorDescription")}
                        <span>
                            {t("Error.errorCode")}
                            {`${error.moduleID}-${error.errorCode}`}
                        </span>
                        <span>{getTranslatedErrorMsg(error)}</span>
                    </StandaloneFeatureNotAvailable>
                }
                replaceFooter={
                    <Button variant={variant} onClick={handleClose}>
                        {t("Shared.ok")}
                    </Button>
                }
            />
        </>
    );
}
